module.exports = __webpack_public_path__ + "img/human_61.54cdf3e4.png";